import { API_SETMEAL_CATEGORY_ALL, API_SETMEAL_LIST } from '@constant'
import http, { createApi } from '@core/fetch'

export default {
  // 案例数是否大于 8 且 是否含有参考案例数
  getConsultCount: createApi(
    '/p/wedding/index.php/Admin/APISetMeal/ConsultCaseNum'
  ),
  mealProperties: createApi('/p/wedding/Admin/APISetMeal/properties'),

  listApi: createApi(API_SETMEAL_LIST), //普通套餐列表

  customListApi: params =>
    http('/p/wedding/index.php/Admin/APICustomSetMeal/list', {
      body: params
    }), //定制套餐列表

  deleteSetMeal: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/delete', {
      body: params
    }), //删除普通套餐

  SoldOut: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/set_sold_out', {
      body: params
    }), //上架下架

  deleteCustomSetMeal: params =>
    http.delete('/p/wedding/index.php/Admin/APICustomSetMeal/dropmeal', {
      body: params
    }), //删除定制套餐

  customEdit: params =>
    http.post('/p/wedding/index.php/Admin/APICustomSetMeal/edit', {
      body: params
    }), //定制套餐编辑

  markListApi: params =>
    http('/p/wedding/index.php/admin/APISetMeal/mealMarks', {
      body: params
    }), //标签列表

  getDetailApi: params =>
    http('/p/wedding/index.php/admin/APISetMeal/info/id/' + params), //标签列表

  toTopApi: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/set_is_top', {
      body: params
    }), //置顶

  add_relative_setmeal: params =>
    http.post('/p/wedding/Admin/APISetMeal/add_relative_setmeal', {
      body: params
    }), //关联

  example_limit: () =>
    http(`/p/wedding/index.php/admin/APIMerchant/example_limit`),

  editApi: params =>
    http('/p/wedding/index.php/admin/APISetMeal/info?id=' + params), //套餐编辑

  categoryListApi: createApi(
    '/p/wedding/Admin/APISetMealMerchantCategory/List'
  ), // 获取分类列表

  shuijingCategoryListApi: createApi(
    '/p/wedding/index.php/Admin/APISetMealMirrorCategory/list'
  ), // 获取水镜分类列表
  shuijingCategoryAdd: params =>
    http.post('/p/wedding/index.php/Admin/APISetMealMirrorCategory/add', {
      body: params
    }), //创建水镜案例分类
  shuijingCategoryEdit: params =>
    http.post('/p/wedding/index.php/Admin/APISetMealMirrorCategory/edit', {
      body: params
    }), //编辑水镜分类

  categoryAdd: params =>
    http.post('/p/wedding/Admin/APISetMealMerchantCategory/Add', {
      body: params
    }), //添加分类

  categoryEdit: params =>
    http.post('/p/wedding/Admin/APISetMealMerchantCategory/Edit', {
      body: params
    }), //编辑分类

  extendsEdit: params =>
    http.post('/p/wedding/Admin/APISetMeal/edit_extends', {
      body: params,
      ignore: [null, undefined]
    }), //编辑案例分类、样片客照

  merchantCategory: params =>
    http(API_SETMEAL_CATEGORY_ALL, {
      body: params
    }), //标签列表

  move: body =>
    http.post('/p/wedding/index.php/admin/APISetMeal/update', { body }),

  getCategories: body =>
    http.get('/p/wedding/Admin/APISetMeal/properties', { body }),
  getCaseSortList: body =>
    http.get('/p/wedding/Admin/APISetMeal/CaseSortList', { body }),
  setWaterMirrorWeight: body =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/waterMirrorWeight', {
      body
    }),
  getMenuList: body =>
    http('/hps/admin/localServerMerchant/category/list', {
      body
    }),
  menuListSort: body =>
    http.post('/p/wedding/Admin/APISetMealMerchantCategory/sort', { body }),
  // 普通商家排序
  saveCaseSort: body =>
    http.post('/p/wedding/index.php/admin/APISetMeal/caseSort', { body }),
  // 团队商家排序
  saveMainCaseSort: body =>
    http.post('/p/wedding/index.php/MainAdmin/APISetMeal/caseSort', { body }),
  draftCastList: body =>
    http('/hms/merchant/appApi/draftCase/list', {
      body
    }),
  getDraftCount: () => http('/hms/merchant/appApi/draftCase/count'),
  delDraft: body =>
    http.post('/hms/merchant/appApi/draftCase/delete', {
      body
    }),
  editDraftApi: body =>
    http('/hms/merchant/appApi/draftWork/detail', {
      body
    }),
  editCase: body =>
    http.post('/p/wedding/Admin/APISetMealMerchantCategory/Edit', {
      body,
      ignore: [null, undefined]
    }),
  // 增加案例分类
  addCaseCate: params =>
    http.post('/p/wedding/Admin/APISetMealMerchantCategory/Add', {
      body: params
    }),
  getStatusCount: body =>
    http('/hps/admin/localServerMerchant/work/statusCount', {
      body
    }),
  // 获取灰度城市
  getGrayCity: createApi.get(
    '/hms/mainLocalService/appApi/channel/commonSetting'
  ),
  // 获取商家发布信息
  getMercantPublicInfo: createApi.get(
    '/hms/hljComplaint/adminApi/proof/merchant/info'
  ),
  // 发起申诉
  lunchComplaint: createApi.post(
    '/hms/hljComplaint/adminApi/proof/case/appeal'
  ),
  // 获取违规列表
  getVioloationList: createApi.get(
    '/hms/hljComplaint/adminApi/punishesCases/list'
  )
}
